declare global {
  interface Window {
    /** Set by Playwright init script before the app bundle loads. */
    __QTRACE_ENABLE_E2E_HOOKS__?: boolean;
  }
}

/** Whether Redux / navigate helpers are exposed for Playwright E2E. */
export function shouldExposePlaywrightHooks(): boolean {
  if (import.meta.env.MODE !== 'production') return true;
  if (import.meta.env.VITE_E2E_HOOKS === 'true') return true;
  return Boolean(window.__QTRACE_ENABLE_E2E_HOOKS__);
}
